import React, { useContext } from "react";
import {Link, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import "./menuItem.scss";
import useRefresh from "../../../../helpers/useRefresh";
import {storesContext} from "../../../stores/stores";

interface MenuItemProps {
    routingAddress: string;
    title: string;
    icon: React.ReactNode;
    children?: any;
    isOpen: boolean;
    handleOpenSubItem?: () => void;
    testId: string;
    history: any;
}

function MenuItem(props: MenuItemProps): JSX.Element {
    const refresh = useRefresh(props.history, props.routingAddress);
    const paginationStore = useContext(storesContext).paginationStore;

    return (
        <List className="menu-item">
            <Link
                onClick={() =>  {
                    paginationStore.clearPagination();
                    if(props.handleOpenSubItem) {
                        if (props.history.location.pathname === props.routingAddress) {
                            refresh();
                        } else {
                            props.handleOpenSubItem();
                            props.history.push(props.routingAddress);
                        }
                    }
                }}
                data-testid={props.testId} className={props.isOpen ? "active-item" : ""}
            >
                <ListItemButton className="item-button">
                    <ListItemIcon className="item-icon">
                        {props.icon}
                    </ListItemIcon>
                    <ListItemText primary={props.title} className="item"/>
                </ListItemButton>
            </Link>

            {props.isOpen ? <>{props.children}</> : null}
        </List>
    );
}

export default MenuItem;
